import { RootInitialState } from '../store/rootReducer';

export const isPrivateDataCollectionAgreed = (state: RootInitialState): boolean => (
  !!(state.cookiesAgreement && state.cookiesAgreement.isPrivateDataCollectionAgreed)
);
